import { CircleDivisionData } from '@.partials';

export const calculateTotalValue = (data: CircleDivisionData[]): number => data.reduce((acc, dataItem) => acc + dataItem.value, 0);
